<rd-popup-default-template
  [title]="'offer.terms_and_condition_modal.title' | translate"
  [dialogContent]="dialogContent">
  <ng-template #dialogContent>
    <ng-container *ngFor="let term of getTermsAndConditionContent()">
      <p class="header" [innerHTML]="term.header"></p>
      <p class="terms-and-condition-body" [innerHTML]="term.body"></p>
      <br />
    </ng-container>
  </ng-template>
</rd-popup-default-template>
